import { PartnerType } from "@/app/utils/partners.enum";
import { apiFGTS } from "../http/httpClient";

export interface requestWithdrawBody {
  type: PartnerType;
  value: number;
  customerId: string;
  Prazo: number;
  propostaId: string;
  prestacao: number;
  CodigoTabela?: string;
  adicionais: {
    convenioDadosId: number;
    valor: string;
    convenioId: number;
  }[];
}

export interface requestWithdrawResponse {
  _id: string;
  contract: string;
  reason_to_cancel: string;
  value: number;
  status: string;
  statusAt: string;
  history: any[];
  seller: string;
  customer: string;
  table: string;
  type: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export async function requestWithdraw(
  body: requestWithdrawBody,
): Promise<requestWithdrawResponse> {
  const { data } = await apiFGTS
    .post<requestWithdrawResponse>(`/transaction`, body)
    .catch((err) => {
      throw err?.response?.data || err;
    });

  return data;
}
